import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    controller: String,
    action: String,
  }

  call() {
    const targetElement = document.querySelector(`[data-controller~="${this.controllerValue}"]`)

    if (!targetElement) {
      return
    }

    const controller = this.application.getControllerForElementAndIdentifier(targetElement, this.controllerValue)

    if (!controller || typeof controller[this.actionValue] !== "function") {
      return
    }

    controller[this.actionValue]()
  }
}
